import { render, staticRenderFns } from "./bake_task_kanban.vue?vue&type=template&id=e976e3ea&scoped=true"
import script from "./bake_task_kanban.vue?vue&type=script&lang=js"
export * from "./bake_task_kanban.vue?vue&type=script&lang=js"
import style0 from "./bake_task_kanban.vue?vue&type=style&index=0&id=e976e3ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e976e3ea",
  null
  
)

export default component.exports